module.exports = __webpack_public_path__ + "static/media/Mego-Fishing.e647e888.png";